import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <footer
      className={`footer-container1 thq-section-padding ${props.rootClassName} `}
    >
      <div className="footer-max-width thq-section-max-width">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/i-charge-roaming" className="footer-navlink">
              <img
                alt="Next-Gen Program Manager Logo"
                src="/Pages/Home/pastedimage-azfl-200h.webp"
                className="footer-image1"
              />
            </Link>
          </div>
          <div className="footer-links">
            <div className="footer-column1">
              <div className="footer-footer-links1 gap-3-5">
                <span className="footer-link1 footer-link thq-link">More</span>
                <a
                  href="/#steps"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link21 footer-link thq-link"
                >
                  Charging Instructions
                </a>
                <a
                  href="/#faq"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link3 footer-link thq-link"
                >
                  FAQ
                </a>
                <Link
                  to="/help-center"
                  className="footer-link4 footer-link thq-link"
                >
                  Help Center
                </Link>
                <Link
                  to="/i-charge-roaming"
                  className="footer-link51 footer-link thq-link"
                >
                  Roaming
                </Link>
                <Link
                  to="/payment-methods"
                  className="footer-link52 footer-link thq-link"
                >
                  Payment Methods
                </Link>
              </div>
            </div>
            <div className="footer-column21">
              <div className="footer-footer-links2 gap-3-5">
                <span className="footer-link61 footer-link thq-link">
                  Media
                </span>
                <Link
                  to="/i-charge-news"
                  className="footer-link71 footer-link thq-link"
                >
                  iCharge news
                </Link>
                <span className="footer-link81 footer-link">Our Partners</span>
                <Link
                  to="/i-charge-news"
                  className="footer-link9 footer-link thq-link"
                >
                  iCharge activities
                </Link>
              </div>
            </div>
            <div className="footer-column22">
              <div className="footer-footer-links3 gap-3-5">
                <span className="footer-link62 footer-link thq-link">
                  Partner with iCharge
                </span>
                <Link
                  to="/who-can-benefit"
                  className="footer-link72 footer-link thq-link"
                >
                  What We Offer
                </Link>
                <a
                  href="/#contact"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link82 footer-link thq-link"
                >
                  iCharge invests
                </a>
              </div>
            </div>
          </div>
          <div className="footer-container2">
            <Link
              to="/terms-and-conditions"
              className="footer-link22 footer-link thq-link"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="footer-link23 footer-link thq-link"
            >
              Terms of Service
            </Link>
            <Link
              to="/terms-and-conditions"
              className="footer-link24 footer-link thq-link"
            >
              Accessibility
            </Link>
          </div>
          <div className="footer-bottom">
            <div className="footer-left-side">
              <div className="footer-footer-links4 gap-1-5">
                <a
                  href="https://mail.google.com/mail/?view=cm&amp;to=support@icharge.app&amp;su=Hello&amp;body=Hi%20there"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link25 footer-link thq-link"
                >
                  Email: support@icharge.app
                </a>
                <a
                  href="https://wa.me/355694080227?text=Hello%20I%20want%20more%20info"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link26 footer-link thq-link"
                >
                  Phone number: +355 69 408 0227
                </a>
              </div>
            </div>
            <div className="footer-right-side">
              <span className="footer-link27 footer-link thq-link">
                copyright © 2025 iCharge.app Services  All Rights Reserved
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  rootClassName: '',
}

Footer.propTypes = {
  rootClassName: PropTypes.string,
}

export default Footer
